namespace Gordic.Epk.WebControls {

    export interface IGEpkSidebar {
        row: Gordic.Wfl.Interface.GPodpisovaKnihaDto,
        grid?: JQuery<HTMLElement>,
        cnt: GContentType<GEpkDbParamsNew>
    }

    export class GEpkSidebar {

        rowDetail: Gordic.Wfl.Interface.GPodpisovaKnihaDto;
        cnt: GContentType<GEpkDbParamsNew>;
        grid?: JQuery<HTMLElement>;
        constructor(obj: IGEpkSidebar) {
            this.cnt = obj.cnt;
            this.rowDetail = obj.row;
            this.grid = obj.grid;
        }

        private sidebarMinWidth = 275;

        public createRightPanels() {

            var rightPanels: GSideBarPanelOptions[] = [];

            if (this.cnt.EpkParams.gin_ele_dmspres === true) {
                // náhled
                rightPanels.push(this.createPanelAttachment());
            }
            // souhrn
            rightPanels.push(this.createPanelPreview());
            // historie schvalování
            rightPanels.push(this.createPanelPodrobnosti());
            // vyřízení žádosti
            rightPanels.push(this.createPanelVyrizZadost());
            // související vazby
            rightPanels.push(this.createPanelSouvisVazby());
            // ověření podpisu
            rightPanels.push(this.createPanelOvereniPodpisu());
            // poznámky
            rightPanels.push(this.createPanelPoznamky());

            return rightPanels;
        }

        private getRow(): Gordic.Wfl.Interface.GPodpisovaKnihaDto | null {
            if (this.grid != null)
                return this.grid.ggrid("activeRow");
            return this.rowDetail;
        }

        //#region -- poznámky --

        private notePanelEl: JQuery<HTMLElement>;
        private notePanelBadge = new GObservableObject({ value: "" });

        private createPanelPoznamky() {

            this.notePanelEl = $("<div>");

            return {
                icon: "fa-sticky-note-o",
                customDiv: this.notePanelEl,
                customClass: "gnotes-panel",
                leaf: {
                    caption: "jres:32000354",   //RC 32000354 : Uživatelské poznámky
                    badge: this.notePanelBadge
                },
                minWidth: this.sidebarMinWidth, 
                id: "panelPoznamky",
                caption: "jres:32000354",	    //RC 32000354 : Uživatelské poznámky
                open: (ev, ctx) => {
                    this._createNotes(this.notePanelEl);
                },
            } as GSideBarPanelOptions;
        }

        private updatePanelPoznamky() {
            this._createNotes(this.notePanelEl);
        }

        private _createNotes(element) {
            var GNotePanel = new Gordic.GNotePanel();
            element.empty();
            var row = this.getRow();
            if (row != null && row.ixp != null) {
                GNotePanel.create(element, this, {
                    ixp: row.ixp,
                    count: (number) => {
                        this.notePanelBadge.value = String(number); this.notePanelBadge.update();
                    },
                });
            }
            else {
                var el = $("<div>").addClass("epk-nahled-sidebar-class");
                el.appendTo(element);
                el.text("jres:32000834"); //RC 32000834 : Poznámky nejsou k dispozici.
            }
        }

        //#endregion

        //#region -- overeni podpisu --

        private overPodpisElement: JQuery<HTMLElement>;
        private tmp_row_overeni: any;

        private createPanelOvereniPodpisu() {

            if (this.overPodpisElement != null) {
                this.overPodpisElement.remove();
            }
            this.overPodpisElement = $("<div>");

            return {
                icon: "gi-history|gi-schvaleno gi-bgw",
                leaf: {
                    caption: "jres:32000385", //RC 32000385 : Podpisy
                }, 
                customDiv: this.overPodpisElement,
                minWidth: this.sidebarMinWidth,
                id: "panelOvereniPodpisu",
                caption: "jres:32000728",							//RC 32000728 : Historie ověření el. dokumentu
                open: (ev, obj) => {
                    this.setPanelOvereniPodpisu();
                }
            } as GSideBarPanelOptions;
        }

        public setPanelOvereniPodpisu(ixb ?: string, filename?: string) {

            if (this.cnt.closed == true)
                return;

            var row = this.getRow();

            if ((row != null) && (row.ixp != null)) {

                if (ixb == null && filename == null && this.tmp_row_overeni === row)
                    return; 
                if (this.overPodpisElement == null)
                    return;

                this.overPodpisElement.empty(); // vyčištění před dalším načtením

                if (this.overPodpisElement.hasClass("gcontent") === false)
                    this.overPodpisElement.gcontent("Gordic.Wfl.WebClient.GHistorieOvereniElDokumentu");

                // hotfix for 490
                // @ts-ignore 
                $.content(this.overPodpisElement).className = "Gordic.Wfl.WebClient.GHistorieOvereniElDokumentu";

                this.overPodpisElement.gcontent("load", {
                    ID: "WFLHistorieOvereniDlg#",
                    Ixp: row.ixp,
                    Ixb: ixb,
                    FileName: filename,
                    mode: Gordic.Wfl.Interface.GHistorieOvereniElDokumentuModeEnum.modal
                });
            }
            else {
                this.tmp_row_overeni = null;
                this.setPanelOvereniEmpty();
            }
            this.tmp_row_overeni = row;
        }

        private setPanelOvereniEmpty() {

            var cnt = $.content(this.overPodpisElement);

            if (cnt.actions.actOveritPodpisHist != null)
                cnt.actions.actOveritPodpisHist.enabled(false);
            if (cnt.actions.actVysledekOveritPodpisHist != null)
                cnt.actions.actVysledekOveritPodpisHist.enabled(false);

            this.overPodpisElement.empty();
            var p7s_element = $("<div>").addClass("epk-nahled-sidebar-class");
            p7s_element.appendTo(this.overPodpisElement);
            p7s_element.text("jres:32000730"); //RC 32000730 : Historie ověření el. dokumentu není k dispozici.
        }

        //#endregion

        //#region -- souvisejici vazby --

        private asyncTaskNameSouvisVazby = "Gordic.Wfl.Server.GEpkSouvisDokCountAsyncTask";
        private souvisejiciVazbyElement: JQuery<HTMLElement>;
        private badgeSouvis = new GObservableObject({ value: "?" });
        private tmp_row_souvis: any;

        private createPanelSouvisVazby() {
            this.souvisejiciVazbyElement = $("<div>");
            return {
                icon: "gi-navazany_zaznam",
                leaf: {
                    caption: "jres:32000034",		//RC 32000034 : Související / vazby
                    badge: this.badgeSouvis                    // počet souvisejících
                },
                minWidth: this.sidebarMinWidth,
                id: "panelLinkedDocs",
                customDiv: this.souvisejiciVazbyElement,
                open: () => {
                    this.updatePanelSouvisVazby();
                }
            } as GSideBarPanelOptions;

        }

        private updatePanelSouvisVazby() {

            var row = this.getRow();

            // ukončení async. úlohy pokud existovala
            let runningTasks = Gordic.Async.GTaskManager.findByClass(this.asyncTaskNameSouvisVazby);
            for (let i = 0; i < runningTasks.length; i++) {
                const task = runningTasks[i];
                task.cancel(true);
            }

            if (row != null && row.ixp != null) {

                let newTask = Gordic.Async.GTaskManager.start<Gordic.Async.IGTaskProgress, any>(this.asyncTaskNameSouvisVazby, { Ixp: row.ixp });

                newTask
                    .getPromise()
                    .then((dto) => {
                        if (this.cnt.closed == true) {
                            Gordic.Async.GTaskManager.cancel(newTask);
                            return;
                        }
                        var result = dto.result;
                        result = result == null || result === 0 ? "0" : result;
                        this.badgeSouvis.value = String(result);
                        this.badgeSouvis.update();
                    })
                    .always(() => {
                        Gordic.Async.GTaskManager.clean(newTask);
                    })

            }

          

            if (row != null && row.ixp != null) {
                if (this.tmp_row_souvis != row) {
                    this.souvisejiciVazbyElement.empty();
                    new GEpkSouvisejiciVazby(this.cnt, this.souvisejiciVazbyElement, row).create();
                }
            }
            else {
                this.souvisejiciVazbyElement.empty();
                var el = $("<div>").addClass("epk-nahled-sidebar-class");
                el.appendTo(this.souvisejiciVazbyElement);
                el.text("jres:32000833"); //RC 32000833 : Související vazby nejsou k dispozici.
            }
            this.tmp_row_souvis = row;
        }

        //#endregion

        //#region -- souhrn --

        private panelPreviewElement: JQuery<HTMLElement>;

        private createPanelPreview() {
            return {
                icon: "gi-info_bold",
                minWidth: this.sidebarMinWidth,
                id: "panelPreview",
                caption: "jres:32000334",							//RC 32000334 : Souhrn
                leaf: "jres:32000334",								//RC 32000334 : Souhrn
                open: (ev, obj) => {
                    this.panelPreviewElement = $(ev.target);
                    setPanelSouhrn(this.panelPreviewElement,this.getRow());
                }
            } as GSideBarPanelOptions;
        }

        //#endregion

        //#region -- nahled -- 

        private epkAttachment: Sidebar.GEpkAttachment;
        private attachment: any;

        /**
         * panel náhledu na přílohy
         * @returns
         */
        private createPanelAttachment() {
            var row = this.getRow();
            this.epkAttachment = new Sidebar.GEpkAttachment(this.cnt);
            return this.epkAttachment.create(row!, (attachment) => {
                this.attachment = attachment;
            }, this.grid);
        }

        // #endregion

        //#region -- historie schvalovani --

        private podrobnostiEl: JQuery<HTMLElement>;
        private tmp_row_historie: any;

        private createPanelPodrobnosti() {
            this.podrobnostiEl = $("<div>");
            return {
                icon: "gi-epk",  
                customDiv: this.podrobnostiEl,
                minWidth: this.sidebarMinWidth,
                id: "panelHistorieSchvalovaniDokumentu",
                caption: "jres:32000019",							//RC 32000019 : Historie schvalování dokumentu
                leaf: "jres:32000335",								//RC 32000335 : Historie
                open: (ev, obj) => {
                    this.updatePanelPodrobnosti(this.podrobnostiEl);
                }
            } as GSideBarPanelOptions;
        }

        private updatePanelPodrobnosti(element: JQuery<HTMLElement>) {
            var row = this.getRow();
            if (this.tmp_row_historie !== row) {								// jedná se o jiný řádek, mohu překreslit náhled, v opačném případě nic neudělám a nechám současný stav
                // vyčistění contentu
                element.empty();
                if (row != null) {
                    var keys = Object.keys(row);
                    // ošetření proti možnosti seskupení na gridu
                    if (keys.length > 1) {
                        this.createPanelPodrobnostiInternal(element);
                    }
                    else
                        $("<div class='epk-nahled-sidebar-class'>").appendTo(element).text("jres:32000418");		// text prázdného náhledu //RC 32000418 : Historie není k dispozici.
                }
                else
                    $("<div class='epk-nahled-sidebar-class'>").appendTo(element).text("jres:32000418");		// text prázdného náhledu //RC 32000418 : Historie není k dispozici.

            }
            this.tmp_row_historie = row;										// uložení řádku do tempu
        }

        private createPanelPodrobnostiInternal(element: JQuery<HTMLElement>) {

            element.empty();
            if (element.hasClass("gcontent") === false) {
                element.gcontent("Gordic.Wfl.WebClient.GHistorieSchvalovani");
            }

            // hotfix for 490
            // @ts-ignore 
            $.content(element).className = "Gordic.Wfl.WebClient.GHistorieSchvalovani";

            var row = this.getRow();

            if (row != null) {
                element.gcontent("load", {
                    ID: "IDEpkHistorieSchvalovani",
                    taskId: "EpkHistorieSchvalovaniGrid",
                    Ixp: row.ixp,
                    SerCislo: row.ser_cislo,
                });
            }
        }

        //#endregion

        //#region -- vyřízení žádosti --

        //private vyrZadostEl: JQuery<HTMLElement>;

        private createPanelVyrizZadost() {
            return {
                icon: "gi-vyrizeno",
                minWidth: this.sidebarMinWidth,
                id: "panelDetailVyrizeni",
                caption: "jres:32000003",							//RC 32000003 : Vyřízení žádosti
                leaf: "jres:32000003",								//RC 32000003 : Vyřízení žádosti
                open: (ev, obj) => {
                    this.preCreatePanelVyrizZadost($(ev.target));
                }
            } as GSideBarPanelOptions;
        }

        private tmp_row_vyriz: any;

        private preCreatePanelVyrizZadost(element: JQuery<HTMLElement>) {

            element.empty();
            var row = this.getRow();

            if (row != null && row.ixp != null) {
                this.createFormVyrizeniZadosti(element);							// vytvoření formuláře vyřízení žádosti
                this.createGridVyrizeniZadosti(element);							// vytvoření seznamu vyřízení žádosti
                this.updatePanelVyrizZadost(element, row);
            }
            else {
                $("<div class='epk-nahled-sidebar-class'>").text("jres:32000841").appendTo(element); //RC 32000841 : Vyřízení žádosti není k dispozici.
            }

        }

        private updatePanelVyrizZadost(element: JQuery<HTMLElement>, row: Gordic.Wfl.Interface.GPodpisovaKnihaDto | null) {

            if (this.cnt.closed === true)													// v případě zavření contentu, skončím v metodě předčasně, ať nedojde k chybě
                return;

            this.updateMenuBarVyrizeniZadosti();					                        // update stavů menu tlačítek v panelu vyřízení žádosti

            if (row == null || row.ixp == null) {								            // řádek seznamu je prázdný, pravděpodobně je prázdný celý seznam
                element.findFields().gfield("clear");	                                    // vyčištění formuláře
                this.vyrZadostGrid.ggrid("setData", []);		                            // vyčištění seznamu
            }
            else {
                element.findFields().gfield("model", "apply", row);		                    // nasetování dat do formuláře
                this.setDataVyrizeniZadosti(element);										// nasetování dat do seznamu sidebaru
            }
        }

        private vyrZadostCnt: GContent;

        private setDataVyrizeniZadosti(element: JQuery<HTMLElement>) {

            if (this.cnt.closed === true)																						            // v případě zavření contentu, skončím v metodě předčasně, ať nedojde k chybě
                return;
            var row = this.getRow();
            if (row === null || row.ixp == null)							                                                    // prázdný řádek, není co setovat, končím ve funkci
                return;

            if (this.vyrZadostCnt == null)
                this.vyrZadostCnt = new GContent("Gordic.Epk.WebControls.GEpkVyrizeniZadosti", element);

            this.vyrZadostCnt.call("GetListElDocFiles", {																            // načtení dat do seznamu el. příloh
                Ixp: row.ixp
            })
                .then((data: Gordic.Wfl.Interface.GAttachmentDto[]) => {
                    if (this.cnt.closed === true) {																				    // v případě zavření contentu, skončím v metodě předčasně, ať nedojde k chybě
                        $.Deferred().reject();
                    }
                    return data;
                })
                .done((data: Gordic.Wfl.Interface.GAttachmentDto[]) => {
                    if (this.cnt.closed === true)																					// v případě zavření contentu, skončím v metodě předčasně, ať nedojde k chybě
                        return;
                    this.vyrZadostGrid.ggrid("setData", new Gordic.Data.View(data, { key: "Id" }));		            // nasetování dat do gridu
                })
        }

        private updateMenuBarVyrizeniZadosti() {
            var row = this.getRow();
            if (this.cnt.actions.actPodrobnosti != null)
                this.cnt.actions.actPodrobnosti.update({ enabled: row !== null ? true : false });
            if (this.cnt.actions.actSouvisejici != null)
                this.cnt.actions.actSouvisejici.update({ enabled: row !== null ? true : false });
            if (this.cnt.actions.actKonverze != null) 
                this.cnt.actions.actKonverze.update({ enabled: row !== null ? true : false });
        }

        private createFormVyrizeniZadosti(element: JQuery<HTMLElement>) {
            var form = $("<div class='panel-vyrizeni-zadosti-sidebar'>").appendTo(element);

            var Form = new Gordic.Forms.Form({
                name: "FormDetailVyrizeniZadosti",
                layoutDescriptor: "L2M2S1, L-4-8-0, M-4-8-0, S-0-12-0, breaks-300-400"
            });

            Form
                .addSection("jres:32000004")			//RC 32000004 : Žádost
                .addRow("jres:32000275")				//RC 32000275 : Identifikátor
                .addField("gstringbox", { name: "ixp", disabled: true })
                .addRow("jres:32000006")				//RC 32000006 : Zn.
                .addField("gstringbox", { name: "cj", disabled: true })
                .addRow("jres:26265010")				//RC 26265010 : Věc
                .addField("gstringbox", { name: "vec", disabled: true })
                .addRow("jres:26265013")				//RC 26265013 : Požadavek
                .addField("gstringbox", { name: "typ_poz_txt", disabled: true })
                .addRow("jres:32000005")				//RC 32000005 : Popis
                .addField("gstringbox", { name: "typ_pozad_pod_txt", disabled: true })
            form.gform("createFrom", Form);
            form.gform("viewMode", "view");		 //- přepnutí do view režimu.

        }

        private vyrZadostGrid: JQuery<HTMLElement>;

        private createGridVyrizeniZadosti(element: JQuery<HTMLElement>) {

            this.vyrZadostGrid = $("<div class='epk-grid-sidebar-vyrizeni-zadosti-class'>").appendTo(element).gautofit({
                parentElement: ".g-sbp-content"
            });

            this.vyrZadostGrid.ggrid({
                name: "GridSidVyrizZadost",
                renderMode: "auto",
                columnMode: "full",
                customClass: "js-gridSidVyrizZadost",
                navigationMode: "row",
                defaultAction: new GAction({
                    name: "gridRowSelectedAct",
                    run: (ev, ctx) => {
                        this.exportPrilohy(ctx.cellInfo.data);
                    }
                }),
                columns: this.formatGridVyrizeniZadosti()
            });

        }

        private formatGridVyrizeniZadosti() {

            var column = new Gordic.Data.GridFormat();

            column
                .addIconColumn({                                            // Globals.ListSupport.TechnickeVlastnostiColumnDlg()
                    name: "technicke_vlastnosti_ico",
                    caption: "jres:32000712", //RC 32000712 : Vlastnosti
                    width: 30,
                    customClass: "center",
                    iconTemplate: (data) => {

                        if (data == null || data.File == null)
                            return;

                        if (data.File.IsSigned === true && data.File.IsTimestamped === true)
                            return Gordic.Gin.Globals.Icons.PodepsanoElektronickySCasovymRazitkem();
                        else if (data.File.IsSigned === false && data.File.IsTimestamped === true)
                            return Gordic.Gin.Globals.Icons.CasoveRazitko();
                        else if (data.File.IsSigned === true && data.File.IsTimestamped === false)
                            return Gordic.Gin.Globals.Icons.PodepsanoElektronicky();
                        else
                            return;
                    }
                })

            column
                .addIconColumn({
                    name: "File.MarkedForSigning",
                    caption: "jres:32000507", //RC 32000507 : Příznak k podepsání
                    width: 30,
                    customClass: "center",
                    iconTemplate: (data) => {

                        if (data == null || data.File == null)
                            return;

                        if (data.File.MarkedForSigning === 1) {
                            return {
                                icon: "gi-epk gi-stack-bg|fa-arrow-right gi-stack-pos--rb gi-bgw g-state-text g-state-info",
                                tooltip: "jres:32000509"
                            }; //RC 32000509 : Označeno pro EPK/schvalovací proces uživatelsky.
                        }
                        else {
                            return;
                        }
                    }
                })

            column
                .addNumberColumn({
                    name: "File.VersionCount",
                    caption: "jres:32000759", //RC 32000759 : Verze
                    description: "jres:32000760", //RC 32000760 : Verze el. souboru
                    width: 40
                })
                .addTextColumn({
                    name: "IsFavorite",
                    caption: "jres:32000013", //RC 32000013 : Typ
                    width: 100,
                    cellTemplate: (data) => {
                        if (data.IsFavorite === true)
                            return "jres:32000711"; //RC 32000711 : Originál
                        return "jres:32000710" //RC 32000710 : Příloha
                    }
                })
                .addTextColumn({
                    name: "File.Type",
                    caption: "jres:32000014", //RC 32000014 : Přípona
                    width: 100,
                })
                .addTextColumn({
                    name: "Name",
                    caption: "jres:32000016", //RC 32000016 : Soubor
                    width: 100,
                })
                .addDateTimeColumn({
                    name: "LastChangeTime",
                    caption: "jres:26265060", //RC 26265060 : Datum změny
                    width: 100,
                })
                .addTextColumn({
                    name: "LastChangeUser",
                    caption: "jres:32000017", //RC 32000017 : Změnu provedl
                    width: 100,
                })
                .addTextColumn({
                    name: "File.Ixb",
                    caption: "jres:32000708", //RC 32000708 : Identifikátor souboru
                    width: 100,
                })
            return column;
        }

        private exportPrilohy(opt: Wfl.Interface.GAttachmentDto) {
            if (opt.File == null || opt.File.Ixb == null)    // není to el. soubor
                return;
            var canEdit = this.cnt.EpkParams.epk_povedeldok;
            Gordic.Wfl.AttachmentUtils.OpenAttachment(this.cnt, opt, canEdit, false)
                .then(() => {
                    //this.refreshGrid();
                })
        }

        //#endregion

        // UPDATE

        public updateSidebar(sidebar: JQuery<HTMLElement>) {

            if (this.cnt.closed)            // zavření contentu - ochrana kvůli pádu
                return;

            var row = this.getRow();

            var panelVyrizZadost = sidebar.gsidebar("getPanel", "panelDetailVyrizeni");			// získám element příslušného panelu v sidebaru
            var panelAttachmentsGrid = sidebar.gsidebar("getPanel", "panelAttachmentsGrid");
            var panelPreview = sidebar.gsidebar("getPanel", "panelPreview");
            var panelHistorieSchvalovaniDokumentu = sidebar.gsidebar("getPanel", "panelHistorieSchvalovaniDokumentu");
            var panelLinkedDocs = sidebar.gsidebar("getPanel", "panelLinkedDocs");
            var panelPoznamky = sidebar.gsidebar("getPanel", "panelPoznamky");
            var panelOvereniPodpisu = sidebar.gsidebar("getPanel", "panelOvereniPodpisu");


            if (panelLinkedDocs.gsbpanel("isVisible") === true)
                this.updatePanelSouvisVazby();

            if (panelVyrizZadost.gsbpanel("isVisible") === true)
                this.updatePanelVyrizZadost(panelVyrizZadost, row);

            if (panelAttachmentsGrid.gsbpanel("isVisible") === true)
                this.epkAttachment.open(row, this.attachment);

            if (panelPreview.gsbpanel("isVisible") === true)
                setPanelSouhrn(this.panelPreviewElement, row);

            if (panelHistorieSchvalovaniDokumentu.gsbpanel("isVisible") === true)
                this.updatePanelPodrobnosti(this.podrobnostiEl);

            if (panelPoznamky.gsbpanel("isVisible") === true)
                this.updatePanelPoznamky();

            if (panelOvereniPodpisu.gsbpanel("isVisible") === true)
                this.setPanelOvereniPodpisu();

        }
    }

}